<template>
  <div id="app" class="container">
    <hw-header></hw-header>
    <div class="row main">
        <div class="col-md-12">
          <h2 class="top_title"><span class="glyphicon glyphicon-menu-left" aria-hidden="true"></span><a href="http://www.helloweba.net/javascript/586.html">基于vue2的canvas时钟倒计时组件</a></h2>
          <div class="container" style="width: 96%; margin: 30px auto">
            <div class="demo" @click="fireCD">
              <countDown 
                :fire="fire"
                time="15"
                :tiping="tiping"
                :tipend="tipend"
                bgCir="rgba(0, 0, 0, .6)"
                @onEnd="onEnd"></countDown>
            </div>
            <p class="text-center">{{msg}}</p>
          </div>
        </div>
    </div>
    <hw-footer></hw-footer>
  </div>
</template>

<script>
import Header from './components/Header'
import Footer from './components/Footer'
import countDown from 'vue-canvas-countdown'

export default {
  name: 'App',
  components: {
    HwHeader: Header,
    HwFooter: Footer,
    countDown
  },
  data () {
    return {
      msg: '点击上方区域开始',
      fire: 0,
      tiping: {
        text: '倒计时进行中',
        color: '#fff'
      },
      tipend: {
        text: '倒计时结束',
        color: '#fff'
      }
    }
  },
  created() {
    this.fire++;
  },
  methods: {
    fireCD () {
      this.msg = '倒计时进行中';
      // 配置参数（更多配置如下表）
      this.tiping = {
        text: '请下注',
        color: '#fff'
      }
      this.tipend = {
        text: '停止下注',
        color: '#fff'
      }

      // 启动倒计时(效果如上图所示)      
      this.fire++ 
    },
    onEnd () {
      console.log('倒计时结束的回调函数')
      this.msg = '已结束，重新点击开始下注';
    }
  },
  mounted: function() {
    
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue